import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import {
  checkpointHandHistorySession,
  HAND_HISTORY_CHECKPOINT_INTERVAL_MS
} from 'utils/handHistorySession';

/** Checkpoint only boundary metadata, including just before native suspension. */
export const useHandHistoryNativeCheckpoint = (
  tableId: string,
  playerGUID: string,
  active: boolean
) => {
  useEffect(() => {
    if (!active || !Capacitor.isNativePlatform()) return;
    const checkpoint = () => checkpointHandHistorySession(tableId, playerGUID);
    const interval = window.setInterval(() => {
      if (document.visibilityState === 'visible') checkpoint();
    }, HAND_HISTORY_CHECKPOINT_INTERVAL_MS);
    window.addEventListener('pagehide', checkpoint);
    let disposed = false;
    let remove: (() => void) | undefined;
    App.addListener('appStateChange', ({ isActive }) => {
      if (!isActive) checkpoint();
    })
      .then((handle) => {
        if (disposed) void handle.remove();
        else
          remove = () => {
            void handle.remove();
          };
      })
      .catch(() => {
        /* The periodic boundary remains available if the bridge is unavailable. */
      });
    return () => {
      disposed = true;
      window.clearInterval(interval);
      window.removeEventListener('pagehide', checkpoint);
      remove?.();
    };
  }, [active, tableId, playerGUID]);
};
